import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo:{}, // 用户信息
    notice:{}, // 公告
    highTaskSwitch:0, // 高额任务 
  },
  mutations: {
    // 用户信息
    changeUser(state,payload){
      state.userInfo = payload || {}
    },
    // 公告信息
    changeNotice(state,payload){
      state.notice = payload || {}
    },
  },
  actions: {
    // 用户信息
    changeUserA(context,param){
      context.commit('changeUser',param)
    },
    // 公告信息
    changeNoticeA(context,param){
      context.commit('changeNotice',param)
    },
  }
})